module.exports = __webpack_public_path__ + "images/9c8d1ebfbdb3435178960ce774402b53.svg";


//////////////////
// WEBPACK FOOTER
// ../public/images/saucey-logo-white.svg
// module id = 777
// module chunks = 0